export const userRoles: { [key: string]: string } = {
  tracker_manager: 'Tracker Manager',
  tracker_admin: 'Tracker Owner',
  senior_manager: 'Senior Manager',
}
